import { createElement } from "react";
import * as icons from "./icons";

type IconName = keyof typeof icons;

type IconProps = {
    icon: IconName,
    title?: string,
    className?: string,
    svgClassName?: string,
    fill?: string,
    onClick?: () => void
}

export const Icon = ({ icon, title, className = "", svgClassName, fill, onClick = () => {} }: IconProps) =>
    <i className={`icon icon-${icon} ${className}`} title={title} onClick={onClick} aria-hidden="true">{createElement(icons[icon], { className: svgClassName, fill })}</i>;
